export default __webpack_public_path__ + "static/media/Bromolla_full.670af0d9.png";